import { Component, Output, EventEmitter, Input } from '@angular/core';


@Component({
    selector: 'modal-video-preview',
    templateUrl: './modal-video-preview.component.html',
    styleUrls: ['./modal-video-preview.component.scss']
})
export class ModalVideoPreview {

    @Input() videoFile: string|null = null;
    @Input() mime: string|null = null;
    @Output() onAction: EventEmitter<string> = new EventEmitter();

    constructor() { }

    ngOnInit(): void {

    }

    onCloseAction(e?: any): void {
        this.onAction.emit('close');
    }


}
